<template>
  <div class="wrapper">
    <h2 v-html="$props.question"></h2>
    <div>
      <img
        class="count-image shadow"
        :src="$props.image"
        :alt="$props.question"
      />
    </div>
    <CountInput :counter.sync="counterVal"> </CountInput>
  </div>
</template>

<script>
import CountInput from "./CountInput";
export default {
  name: "CountImageInput",
  components: { CountInput },
  props: {
    question: {
      type: String,
      required: true
    },
    counter: {
      type: Number,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      counterVal: this.counter
    };
  },
  watch: {
    counterVal: function() {
      this.$emit("update:counter", this.counterVal);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: stretch;
}
</style>
